import { render, staticRenderFns } from "./GeneralJournal.vue?vue&type=template&id=a8681830&"
import script from "./GeneralJournal.vue?vue&type=script&lang=js&"
export * from "./GeneralJournal.vue?vue&type=script&lang=js&"
import style0 from "./GeneralJournal.vue?vue&type=style&index=0&id=a8681830&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports